import React, { useState } from "react";
import {
  Box,
  Typography,
  Collapse,
  Stack,
  Card,
  IconButton,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import PersonIcon from "@mui/icons-material/Person";
import { useTranslation } from "react-i18next";
import { ProjectMember } from "../../types";

interface Props {
  members: ProjectMember[];
}

const ProjectMembersAccordion: React.FC<Props> = ({ members }) => {
  const { t } = useTranslation();
  const [open, setOpen] = useState(true);

  return (
    <Box
      sx={{
        borderRadius: 2,
        background: "#fff",
        mb: 2,
        minWidth: 280,
        maxWidth: 500,
      }}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          cursor: "pointer",
          justifyContent: "space-between",
        }}
        onClick={() => setOpen((o) => !o)}
      >
        <Box sx={{ display: "flex", alignItems: "center" }}>
          <Typography
            variant="h4"
            sx={{ flex: 1, fontSize: { xs: "1.2rem", sm: "1.5rem" } }}
          >
            {t("projects.detail.membersTitle") || "Участники"}
          </Typography>
          <IconButton
            size="small"
            sx={{
              transition: "transform 0.2s",
              mr: 1,
              transform: open ? "rotate(180deg)" : "rotate(0deg)",
              color: "grey.700",
            }}
            disableRipple
            tabIndex={-1}
          >
            <ExpandMoreIcon />
          </IconButton>
        </Box>
      </Box>

      <Collapse in={open} timeout="auto" unmountOnExit>
        <Box sx={{ mt: 1.5 }}>
          {members.length === 0 ? (
            <Typography
              color="text.secondary"
              sx={{ fontSize: "0.95rem", py: 2, textAlign: "center" }}
            >
              {t("projects.detail.noMembers") || "Нет участников"}
            </Typography>
          ) : (
            <Stack spacing={1}>
              {members.map((member) => (
                <Card
                  key={member.id}
                  sx={{
                    width: "100%",
                    mb: 1,
                    boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.1)",
                    border: "none",
                    px: 2,
                    py: 1,
                  }}
                >
                  <Box sx={{ display: "flex", alignItems: "center" }}>
                    <PersonIcon sx={{ color: "#4467A5", mr: 1 }} />
                    <Box sx={{ flex: 1 }}>
                      <Typography sx={{ fontSize: { xs: "0.92rem", sm: "1rem" } }}>
                        {member.name}
                      </Typography>
                      {member.projectRole && (
                        <Typography variant="caption" color="text.secondary">
                          {member.projectRole}
                        </Typography>
                      )}
                    </Box>
                  </Box>
                </Card>
              ))}
            </Stack>
          )}
        </Box>
      </Collapse>
    </Box>
  );
};

export default ProjectMembersAccordion;

